import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/src/nuxt/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/opt/buildhome/repo/src/nuxt/layouts/error.vue").then(m => m.default || m)),
  iframe: defineAsyncComponent(() => import("/opt/buildhome/repo/src/nuxt/layouts/iframe.vue").then(m => m.default || m)),
  static: defineAsyncComponent(() => import("/opt/buildhome/repo/src/nuxt/layouts/static.vue").then(m => m.default || m)),
  symbol: defineAsyncComponent(() => import("/opt/buildhome/repo/src/nuxt/layouts/symbol.vue").then(m => m.default || m))
}